/**
 * Same-origin base URL for an @itk-wasm package's self-hosted pipelines.
 *
 * The files are emitted under /itk/<dir>/ by the itkPipelines plugin in
 * vite.config.ts (which lists every pipeline shipped). The URL must be
 * absolute: itk-wasm hands it to its own pipeline worker, which resolves a
 * relative one against the worker script, not the page.
 *
 * Module state is per realm, so each context that runs a pipeline (the main
 * thread, the DICOM import worker) must set its own base URL.
 */
export function itkPipelinesBaseUrl(dir: 'image-io' | 'dicom'): string {
    return new URL(`${import.meta.env.BASE_URL}itk/${dir}`, globalThis.location.origin).href;
}
